module.exports = __webpack_public_path__ + "static/media/Upload Stock Graphic Page_1576839526099.a2c9b721.png";